module.exports = __webpack_public_path__ + "img/house.f15821d0.svg";